import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo, setJsonLd } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import CategorySection from "./components/CategorySection";
import LatestSection from "./components/LatestSection";
import RankSection from "./components/RankSection";
import DownloadGuide from "./components/DownloadGuide";
import FaqSection from "./components/FaqSection";
import WordSection from "./components/WordSection";

export default function Home() {
  useSeo({
    title: "奶水动漫 - 热门动画免费在线观看全集，高清资源下载",
    description:
      "奶水动漫网提供热门动画免费在线观看全集与高清下载资源。覆盖热血、奇幻、科幻、恋爱、悬疑等多类型动画，资源持续更新，无需繁琐步骤点开即追更，一站式找番、看番、存番。",
    keywords: "奶水动漫,奶水动漫免费,奶水动漫全集,奶水动漫资源,奶水动漫下载,奶水动漫在线,奶水动漫观看",
  });

  setJsonLd("ld-website", {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "奶水动漫",
    url: "https://fullflick.github.io/",
    description: "奶水动漫网提供热门动画免费在线观看、全集收录与高清下载资源。",
  });

  setJsonLd("ld-faq", {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      { "@type": "Question", name: "奶水动漫可以免费在线观看吗？", acceptedAnswer: { "@type": "Answer", text: "可以。奶水动漫提供热门动画免费在线观看服务，无需注册登录，点开详情页选择对应集数即可播放。" } },
      { "@type": "Question", name: "如何下载高清资源到本地？", acceptedAnswer: { "@type": "Answer", text: "进入番剧详情页选择集数与清晰度，复制下载直链或使用离线下载工具即可保存，支持 1080P 与 4K 画质。" } },
      { "@type": "Question", name: "新番的更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "资源站持续整理更新，热门新番同步更新集数，完结番剧一次性收录全集。" } },
    ],
  });

  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main>
        <Hero />
        <HotSection />
        <CategorySection />
        <LatestSection />
        <RankSection />
        <DownloadGuide />
        <FaqSection />
        <WordSection />
      </main>
      <Footer />
    </div>
  );
}